<template>
  <div class="postal-code-input">
    <v-text-field
      v-bind="{
        ...$attrs,
      }"
      :id="postalCodeId"
      append-icon="search"
      :append-inner-icon="pageloading ? 'mdi-spin mdi-loading' : ''"
      @keyup="(e) => !disabled && searchAddress(e, e.target.value)"
      placeholder="Search Address"
      solo
      ref="searchinput"
      hide-spin-buttons
      flat
      color="cyan"
      :disabled="disabled"
    >
    </v-text-field>

    <v-menu
      max-width="300"
      v-model="searchMenu"
      v-if="!disabled && postalAddressList.length > 1"
      max-height="400"
      offset-y
      ref="searchmenu"
      left
      :activator="`#${postalCodeId}`"
    >
      <v-list>
        <v-list-item
          v-for="(item, index) in postalAddressList"
          :key="index"
          :value="index"
          class="border-b"
          @click="setAddress(item)"
        >
          <template v-slot:prepend>
            <v-icon size="24" class="me-3" :icon="'mdi-map'"></v-icon>
          </template>
          <v-list-item-title class="white-space-pre-wrap">{{
            item.description
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { QUERY } from "@/core/services/store/request.module";
import { lowerCase } from "lodash";
import ValidationMixin from "@/core/plugins/validation-mixin";

export default {
  mixins: [ValidationMixin],
  name: "pending-line-item",
  props: {
    country: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: "postal-menu-activator",
    },
    countryCode: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    disabled(val) {
      if (val) {
        this.searchMenu = false;
        this.postalAddressList = [];
      }
    },
  },
  data: () => {
    return {
      pageloading: false,
      timeoutLimit: 500,
      timeout: null,
      searchMenu: false,
      postalAddressList: [],
      postalCodeId: "postal-id" + +new Date(),
    };
  },
  computed: {
    getCountryCode() {
      return this.countryCode;
    },
  },
  methods: {
    setAddress(address) {
      this.searchMenu = false;
      this.$emit("update:address", address);
    },
    searchAddress(event, number) {
      if (this.disabled) return;
      if (
        event &&
        (event.key == "ArrowUp" ||
          event.key == "ArrowDown" ||
          event.key == "ArrowLeft" ||
          event.key == "ArrowRight" ||
          event.key == "Enter")
      ) {
        return false;
      }
      if (number) {
        let _this = this;
        let url = "";
        // let Request = {};
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
          if (_this.country == "singapore") {
            /*  if (number && number.length < 6 && this.country == "singapore") { */
            url = "https://micro.genicsolutions.com.sg/api/onemap-api/search";
            _this.$store
              .dispatch(QUERY, {
                url: url,
                data: { search: number },
              })
              .then(({ data }) => {
                _this.processAddressData(data);
              })
              .catch((error) => {
                _this.logError(error);
              });
          } else {
            url = "https://micro.genicsolutions.com.sg/api/google-api/search";
            _this.$store
              .dispatch(QUERY, {
                url: url,
                data: {
                  search: number,
                  country: _this.getCountryCode ? _this.getCountryCode : "in",
                },
              })
              .then(({ data }) => {
                _this.processAddressData(data);
              })
              .catch((error) => {
                _this.logError(error);
              });
          }
        }, _this.timeoutLimit);
      }
    },
    processAddressData(data) {
      if (data && data.length) {
        this.searchMenu = true;
        if (lowerCase(this.getCountryCode) != "sg") {
          this.postalAddressList = data.map((row) => {
            const _address_2 = row.description;
            return {
              address1: _address_2,
              address2: null,
              unit_number: null,
              postal_code: "000000",
              description: row.description,
            };
          });
        } else {
          this.postalAddressList = data.map((row) => {
            const _unit_number = null;
            const _address_1 = row.road_name != "NIL" ? row.road_name : null;
            const _address_2 = row.building != "NIL" ? row.building : null;
            const _postal_code =
              row.postal_code != "NIL" ? row.postal_code : "000000";
            const longitude = row.longitude != "NIL" ? row.longitude : null;
            const latitude = row.latitude != "NIL" ? row.latitude : null;

            return {
              address1: _address_1,
              address2: _address_2,
              unit_number: _unit_number,
              longitude: longitude,
              latitude: latitude,
              postal_code: _postal_code,
              description: row?.address,
            };
          });
        }
      } else {
        this.searchMenu = false;
      }

      if (this.postalAddressList && this.postalAddressList.length == 1) {
        this.setAddress(this.postalAddressList[0]);
      }
    },
  },
};
</script>
<style scoped></style>
